import { TAppState } from '../../types/appState';

export const subAgentsSelector = (state: TAppState) => state.subAgents;
